module.exports = __webpack_public_path__ + "static/media/three-box-logo-light.d6204340.svg";